module.exports = __webpack_public_path__ + "static/media/671.11c7eb18.webp";